import type { IFetchService } from "app/services/fetchService";
import type {
    IntentSelectedTopicDto,
    IntentTopicDescriptionDto,
    IntentTopicDto,
    IntentTopicRequestDto,
    SaveIntentTopicRequestDto,
    SaveIntentTopicResponseDto,
} from "../../types/dto";
import type { IntentApprovedTerms } from "app/pages/sales-intelligence/sub-modules/intent/types/common";

const createIntentApiService = (fetchService: IFetchService) => {
    return {
        fetchSelectedIntentTopic(): Promise<IntentSelectedTopicDto> {
            return fetchService.get("/sales-api/intent-topics");
        },
        fetchIntentTopics(dto: IntentTopicRequestDto): Promise<IntentTopicDto> {
            return fetchService.post("/sales-api/intent-topics/search", dto);
        },
        saveIntentTopics(dto: SaveIntentTopicRequestDto): Promise<SaveIntentTopicResponseDto> {
            return fetchService.post("/sales-api/intent-topics", dto);
        },
        fetchIntentTopicsDescription(): Promise<IntentTopicDescriptionDto> {
            return fetchService.get("/sales-api/intent-topics/description");
        },
        fetchIntentUserAdmins(): Promise<string[]> {
            return fetchService.get("/sales-api/intent-topics/contact-admin");
        },
        saveIntentUserApprovalTerms(): Promise<unknown> {
            return fetchService.post("/sales-api/intent-topics/terms");
        },
        fetchIntentApproval(): Promise<IntentApprovedTerms> {
            return fetchService.get("/sales-api/intent-topics/terms");
        },
    };
};

export default createIntentApiService;
